export default class LoadingAnimation {
  static type_border(){
    const buttonElement = document.getElementsByClassName('js-loadingAnimationTypeBorder')[0];
    const loadingPageElement = document.getElementById('loading-page');
    if(!buttonElement) return;
    if(!loadingPageElement) return;

    buttonElement.addEventListener('click', () => {
      loadingPageElement.classList.remove('is-hide');
    });
  }
  static typeBorderWhenSubmit(){
    const loadingPageElement = document.getElementById('loading-page');
    if(!loadingPageElement) return;

    loadingPageElement.classList.remove('is-hide');
  }

  static startWaitingSpinner() {
    const loadingElement = document.getElementById('loading');
    if(!loadingElement) return;

    loadingElement.classList.remove('is-hide');
  }

  static endWaitingSpinner() {
    const loadingElement = document.getElementById('loading');
    if(!loadingElement) return;

    loadingElement.classList.add('is-hide');
  }
}
